import { isTextNode } from 'anodum';

const getElementFromNode = (node) => (isTextNode(node) ? node.parentElement : node);

export default getElementFromNode;
